'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasFailed = exports.isPending = exports.getFailureState = exports.getPendingState = exports.getThunkState = exports.initialState = exports.FAILURE = exports.PENDING = undefined;

var _initialState;

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PENDING = exports.PENDING = 'pending';
var FAILURE = exports.FAILURE = 'failure';

var initialState = exports.initialState = (_initialState = {}, _defineProperty(_initialState, PENDING, {}), _defineProperty(_initialState, FAILURE, {}), _initialState);

var getIn = function getIn(state, name) {
  if (typeof name === 'undefined') {
    return !!(0, _find2.default)(state, function (value) {
      return !!value;
    });
  } else if (Array.isArray(name)) {
    return !!(0, _find2.default)((0, _pick2.default)(state, name), function (value) {
      return !!value;
    });
  } else if (Object.prototype.hasOwnProperty.call(state, name)) {
    return !!state[name];
  }
  return false;
};

var getThunkState = exports.getThunkState = function getThunkState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!Object.prototype.hasOwnProperty.call(state, 'thunk')) {
    throw new Error('[redux-saga-thunk] There is no thunk state on reducer');
  }
  return state.thunk || {};
};

var getPendingState = exports.getPendingState = function getPendingState(state) {
  return getThunkState(state)[PENDING] || initialState[PENDING];
};

var getFailureState = exports.getFailureState = function getFailureState(state) {
  return getThunkState(state)[FAILURE] || initialState[FAILURE];
};

/**
 * Tells if an action is pending
 * @example
 * const mapStateToProps = state => ({
 *   fooIsPending: isPending(state, 'FOO'),
 *   fooOrBarIsPending: isPending(state, ['FOO', 'BAR']),
 *   anythingIsPending: isPending(state)
 * })
 */
var isPending = exports.isPending = function isPending(state, name) {
  return getIn(getPendingState(state), name);
};

/**
 * Tells if an action has failed
 * @example
 * const mapStateToProps = state => ({
 *   fooHasFailed: hasFailed(state, 'FOO'),
 *   fooOrBarHasFailed: hasFailed(state, ['FOO', 'BAR']),
 *   anythingHasFailed: hasFailed(state)
 * })
 */
var hasFailed = exports.hasFailed = function hasFailed(state, name) {
  return getIn(getFailureState(state), name);
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga-thunk/dist/selectors.js
// module id = 1149
// module chunks = 0